const eventsMixin = {
  data () {
    return {
      my_events: [],
    }
  },
  methods: {
    loadMyEvents: function() {
      fetch(this.$root.my_events_url()).then(response => response.json())
      .then(json => {
        this.my_events = json.map(event => {
          event.show = true;
          event.filter = true;
          event.start_date = event.start_date.split(' ')[0].split('-').reverse().join('/');
          event.color = event.category_color || '#888888';
          return event;
        });
      })
      .catch(error => {
        console.error('SE HA PRODUCIDO UN ERROR EN TcEventsMyCalendar', error);
      })
    },
    IsSubscribed: function(event) {
      return undefined != _.find(this.my_events, { 'event_id': event.id });
    },
  }
}

export default eventsMixin
